import { Allocation } from './Allocation';
import { BaseModel } from './BaseModel';
import { Node } from './Node';

export class ServerTransfer extends BaseModel {
    public id = -1;
    public serverId = -1;
    public oldNode = -1;
    public newNode = -1;
    public oldAllocation = -1;
    public newAllocation = -1;
    public oldAdditionalAllocations: number[] = [];
    public newAdditionalAllocations: number[] = [];
    public successful: boolean | null = null;
    public archived = false;
    public scheduled = false;
    public startOnCompletion = false;
    public isV2Transfer = false;
    public isInProgress = false;
    public isScheduled = false;
    public createdAt = '';
    public updatedAt = '';

    public get oldNodeModel(): Node | null {
        return this.getRelationship('oldNode') || null;
    }

    public get newNodeModel(): Node | null {
        return this.getRelationship('newNode') || null;
    }

    /**
     * All allocations the transfer will bind on the destination node, primary
     * first. Hydrated from the `newAllocations` include; empty when the
     * include wasn't requested or the row carries no allocations.
     */
    public get newAllocationsList(): Allocation[] {
        const all: Allocation[] = this.getRelationship('newAllocations') || [];
        if (all.length <= 1) return all;

        // Sort the primary (matching newAllocation id) to the front; preserve
        // the rest in their original order for stable rendering.
        const primaryIdx = all.findIndex((a) => a.id === this.newAllocation);
        if (primaryIdx <= 0) return all;
        const copy = [...all];
        const [primary] = copy.splice(primaryIdx, 1);
        return [primary, ...copy];
    }
}
